import { TOI_LIVE_DOMAIN } from '../constants';

export function getSiteDomainName() {
  return `${TOI_LIVE_DOMAIN}/`;
}

export function videoIframeTemplate() {
  return 'vod_player_react.cms';
}

export function miniTVIframeTemplate() {
  return 'minitv_v2.cms';
}

const connectedDomains = ['zigwheels.com', 'mediawire.in'];
export function isConnectedDomain(url) {
  if (typeof url !== 'string') {
    return false;
  }
  let isConnectedDomainValue = false;
  connectedDomains.forEach(domainName => {
    if (url.indexOf(domainName) >= 0) {
      isConnectedDomainValue = true;
    }
  });
  return isConnectedDomainValue;
}

export function isMediawireDomain(url) {
  if (typeof url !== 'string') {
    return false;
  }
  return url.indexOf('mediawire.in') >= 0;
}

const nonRelAttrDomains = [
  'recipes.timesofindia.com',
  'gadgetsnow.indiatimes.com',
];
export function isNonRelAttrDomain(url) {
  if (typeof url !== 'string') {
    return false;
  }
  let isNonRelAttrDomainValue = false;
  nonRelAttrDomains.forEach(domainName => {
    if (url.indexOf(domainName) >= 0) {
      isNonRelAttrDomainValue = true;
    }
  });
  return isNonRelAttrDomainValue;
}
